import React, { useEffect, useState } from "react";
import NotificationService from "venuescanner-js/services/models/userNotifications";
import { leadNotificationPeriods } from "venuescanner-js/constants/user_notifications";

import IconClose from "venuescanner-js/react/components/Objects/Icons/IconClose";

const LeadsNotificationSettings = ({ handleClose }) => {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    NotificationService.fetch().then((res) => {
      setNotifications(res);
      setLoading(false);
    });
  }, []);

  const handeSelectOption = async () => {
    notifications.leads = await selectedOption;
    handleClose();
  };

  return (
    <div className="leads-notification-settings">
      <div className="leads-notification-settings__wrapper">
        {loading ? (
          <span className="loading" />
        ) : (
          <>
            <IconClose handleClick={() => handleClose()} />
            {selectedOption ? (
              <>
                <p>
                  {selectedOption === leadNotificationPeriods.NEVER &&
                    "Please confirm that you no longer wish to receive emails when you get a new MatchLead?"}
                  {selectedOption === leadNotificationPeriods.IMMEDIATELY &&
                    "Please confirm that you want to receive a new email for every MatchLead you get?"}
                  {selectedOption === leadNotificationPeriods.ONCEADAY &&
                    "Please confirm that you want to receive one MatchLead email per day that details all of your new MatchLeads?"}
                </p>
                <div className="leads-notification-settings__ctas">
                  <button
                    className="button button--outline-light"
                    onClick={() => setSelectedOption(null)}
                  >
                    Back
                  </button>
                  <button
                    className="button button--light"
                    onClick={() => handeSelectOption()}
                  >
                    Confirm
                  </button>
                </div>
              </>
            ) : (
              <>
                <h3 className="leads-notification-settings__title">
                  &#128276; MatchLead email settings
                </h3>
                <p>
                  {notifications.leads === leadNotificationPeriods.NEVER &&
                    "You are not currently receiving any MatchLead emails. "}
                  {notifications.leads ===
                    leadNotificationPeriods.IMMEDIATELY &&
                    "You are currently receiving a new email for every new MatchLead. "}
                  {notifications.leads === leadNotificationPeriods.ONCEADAY &&
                    "You are currently receiving one MatchLead email per day that details all of your new MatchLeads. "}
                  You can change this by selecting any one of the available
                  options below.
                </p>
                <div className="leads-notification-settings__options">
                  {notifications.leads !==
                    leadNotificationPeriods.IMMEDIATELY && (
                    <span
                      className="leads-notification-settings__option p"
                      onClick={() =>
                        setSelectedOption(leadNotificationPeriods.IMMEDIATELY)
                      }
                    >
                      Email me every time I get a MatchLead
                    </span>
                  )}
                  {notifications.leads !== leadNotificationPeriods.ONCEADAY && (
                    <span
                      className="leads-notification-settings__option p"
                      onClick={() =>
                        setSelectedOption(leadNotificationPeriods.ONCEADAY)
                      }
                    >
                      Send one email per day with new MatchLeads
                    </span>
                  )}
                  {notifications.leads !== leadNotificationPeriods.NEVER && (
                    <span
                      className="leads-notification-settings__option p"
                      onClick={() =>
                        setSelectedOption(leadNotificationPeriods.NEVER)
                      }
                    >
                      I don't want to receive MatchLead emails
                    </span>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default LeadsNotificationSettings;
